// ADHDROOM cart page (sections/adr-cart.liquid).
// Quantity buttons, Remove and the note change Shopify's cart in place, without reloading the page:
//   /cart/change.js  changes a line, and sends back this section freshly drawn (Shopify's bundled section rendering)
//   /cart/update.js  saves the note
// The bag and the drawer in the bar are updated too (window.ADRCart from assets/adr-chrome.js). When the cart changes
// from the drawer or from an Add to cart button on this page, the section is redrawn to match.

(function () {
  if (window.ADRCartPage) return;
  window.ADRCartPage = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function page() { return document.querySelector('[data-adr-cartpage]'); }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) { return r.ok ? data : Promise.reject(data); });
    });
  }

  // The same fingerprint the section writes into data-sig, so we only redraw when something really changed
  function sigOf(cart) {
    return cart.item_count + '|' + cart.total_price + '|' + cart.items.map(function (i) { return i.key + ':' + i.quantity + ','; }).join('');
  }

  function swap(html) {
    var current = page();
    if (!current || !html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-adr-cartpage]');
    if (!fresh) return;
    // keep whatever is being typed in the note
    var note = current.querySelector('[data-note]');
    var freshNote = fresh.querySelector('[data-note]');
    if (note && freshNote) freshNote.value = note.value;
    // keep the quick-pay buttons (Shop Pay, PayPal...) that Shopify already set up
    var express = current.querySelector('[data-cart-express]');
    var freshExpress = fresh.querySelector('[data-cart-express]');
    if (express && freshExpress) freshExpress.replaceWith(express);
    current.replaceWith(fresh);
    watchBar();
  }

  function redraw() {
    var el = page();
    if (!el) return;
    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(el.getAttribute('data-section')))
      .then(function (r) { return r.text(); })
      .then(swap);
  }

  // After a redraw, put the keyboard back where it was: the same button on the same line, else the next line, else Checkout
  function refocus(key, which) {
    var el = page();
    if (!el) return;
    var row = el.querySelector('.cp-item[data-key="' + key + '"]');
    var target = (row && (row.querySelector(which) || row.querySelector('button, input, a'))) ||
      el.querySelector('.cp-item button, .cp-item input') || el.querySelector('.cp-summary .btn-buy, a[href]');
    if (target) target.focus();
  }

  function change(row, quantity, which) {
    var el = page();
    var key = row.getAttribute('data-key');
    var hadFocus = row.contains(document.activeElement);
    var error = row.querySelector('.cp-error');
    row.classList.add('is-busy');
    post('cart/change.js', {
      id: row.getAttribute('data-key'),
      quantity: Math.max(0, quantity),
      sections: el.getAttribute('data-section'),
      sections_url: window.location.pathname
    }).then(function (cart) {
      swap(cart.sections && cart.sections[el.getAttribute('data-section')]);
      if (window.ADRCart && window.ADRCart.render) window.ADRCart.render(cart);
      if (hadFocus && which) refocus(key, which);
    }).catch(function (err) {
      // e.g. not enough in stock
      row.classList.remove('is-busy');
      if (error) {
        error.textContent = (err && (err.description || err.message)) || 'Sorry, that could not be changed.';
        error.hidden = false;
      }
      var input = row.querySelector('[data-qty]');
      if (input) input.value = row.getAttribute('data-qty');
    });
  }

  document.addEventListener('click', function (e) {
    var row = e.target.closest('[data-adr-cartpage] .cp-item');
    if (!row) return;
    var step = e.target.closest('[data-step]');
    var remove = e.target.closest('[data-remove]');
    if (!step && !remove) return;
    e.preventDefault();
    if (row.classList.contains('is-busy')) return;
    change(row, remove ? 0 : +row.getAttribute('data-qty') + +step.getAttribute('data-step'),
      remove ? '[data-remove]' : '[data-step="' + step.getAttribute('data-step') + '"]');
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-adr-cartpage] [data-qty]')) return;
    var row = e.target.closest('.cp-item');
    var qty = parseInt(e.target.value, 10);
    if (isNaN(qty) || qty < 0) { e.target.value = row.getAttribute('data-qty'); return; }
    if (qty !== +row.getAttribute('data-qty')) change(row, qty, '[data-qty]');
  });

  // Enter in a quantity box changes that line instead of submitting the whole form
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-adr-cartpage] [data-qty]')) {
      e.preventDefault();
      e.target.blur();
    }
  });

  // Save the note a moment after typing stops (it is also sent with the form on Checkout)
  var noteTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-adr-cartpage] [data-note]')) return;
    clearTimeout(noteTimer);
    var value = e.target.value;
    noteTimer = setTimeout(function () { post('cart/update.js', { note: value }).catch(function () {}); }, 500);
  });

  // The drawer or an Add to cart button changed the cart: redraw if this page no longer matches
  document.addEventListener('adr:cart', function (e) {
    var el = page();
    if (el && e.detail && sigOf(e.detail) !== el.getAttribute('data-sig')) redraw();
  });

  // Phones: the floating Checkout bar shows while the summary's Checkout button is off screen
  var barWatch;
  function watchBar() {
    if (barWatch) barWatch.disconnect();
    var el = page();
    var bar = el && el.querySelector('.cp-bar');
    var real = el && el.querySelector('.cp-summary .btn-buy');
    if (!bar || !real || !('IntersectionObserver' in window)) return;
    var realOn = true, footerOn = false;
    var footer = document.querySelector('.adr-footer, footer.footer');
    barWatch = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.target === real) realOn = en.isIntersecting;
        else footerOn = en.isIntersecting;
      });
      // shows while the real Checkout button is off screen, and steps aside for the footer
      bar.classList.toggle('is-on', !realOn && !footerOn);
    });
    barWatch.observe(real);
    if (footer) barWatch.observe(footer);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchBar);
  else watchBar();
})();
